import api from '../services/api';

/**
 * We check to see if we support the currency code
 * @param {string} currencyCode
 */
export const currencyAvailable = (currencyCode) => {
    const availableCurrencies = ['USD', 'GBP', 'AUD', 'EUR', 'NZD', 'NOK', 'SEK', 'CHF', 'AED', 'ZAR', 'DKK', 'CAD', 'HKD', 'SGD','JPY','ARS','BRL','MYR','KRW'];
    return availableCurrencies.indexOf(currencyCode) !== -1;
};
